import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/provider-actions';
import { ProgramBookActions, ProviderActions, SeanceActions, StudentActions } from '../constants';
import { IProgramBook } from 'src/types/programBook';
import { IProgramBookAnswers } from 'src/types/programBookAnswers';

export interface ProgramBookState {
    inProgress: boolean;
    error: string;
    data: Paginated<IProgramBook>;
    current: IProgramBook | null;
    miniLoaderFor: { [key: string]: boolean };
    currentFiles: any | null;
}

export interface ProgramBookAnswersState {
    inProgress: boolean;
    error: string;
    data: Paginated<IProgramBookAnswers>;
    current: IProgramBookAnswers | null;
    miniLoaderFor: { [key: string]: boolean };
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    miniLoaderFor: {},
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function programBooks(state: ProgramBookState = initialState, action: Actions | any): ProgramBookState {
    switch (action.type) {
        case requestType(ProgramBookActions.PROGRAM_BOOK_PERSIST):
            return { ...state, error: '', inProgress: true };
        case successType(ProgramBookActions.PROGRAM_BOOK_PERSIST):
            return { ...state, inProgress: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_PERSIST):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY):
            return {
                ...state,
                inProgress: false,
                current: action.payload,
            };
        case failureType(ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ProgramBookActions.PROGRAM_BOOK_FETCH):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                            updatedAt: null,
                        },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProgramBookActions.PROGRAM_BOOK_FETCH):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_FETCH):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };


        case requestType(ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                            updatedAt: null,
                        },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };


        case requestType(ProgramBookActions.PROGRAM_BOOK_CREATE_FILES):
            return { ...state, miniLoaderFor: { FILE: true }, error: '' };
        case successType(ProgramBookActions.PROGRAM_BOOK_CREATE_FILES):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curFiles,
            };

        case failureType(ProgramBookActions.PROGRAM_BOOK_CREATE_FILES):
            return { ...state, error: action.error.response.data?.errorMessage ?? 'Unknown error', miniLoaderFor: {} };

        case requestType(ProgramBookActions.DELETE_FILE_PROGRAM_BOOK):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(ProgramBookActions.DELETE_FILE_PROGRAM_BOOK):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curNewFiles,
            };
        case failureType(ProgramBookActions.DELETE_FILE_PROGRAM_BOOK):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(ProgramBookActions.PROGRAM_BOOK_FETCH_FILES):
            return { ...state, error: '', };
        case successType(ProgramBookActions.PROGRAM_BOOK_FETCH_FILES):
            return { ...state, currentFiles: action.payload };
        case failureType(ProgramBookActions.PROGRAM_BOOK_FETCH_FILES):
            return { ...state, error: action.error };

        default:
            return state;
    }
}
